import { mapState } from "vuex";
import ticketsService from "../src/services/ticketsService";
import moment from "moment";
import ticketDashboardService from "../src/services/ticketDashboardService";
export default {
	filters: {
		timeLabel(val) {
			if(val) {
        if(val.toString().includes('.')) {
          let label = val.toString().split('.')[0];
          let labelArr = label.split(' ');
          if(labelArr && labelArr.length && labelArr.length == 3) {
            let labelTimeStamp = labelArr[2];
            let timeStampArr = labelTimeStamp.split(':');
            if(timeStampArr && timeStampArr.length && timeStampArr.length == 3) {
							let timeStampLabel = '';
							if(Number(labelArr[0]) > 0) {
								timeStampLabel = `${labelArr[0]} ${labelArr[1]}`;
							}
              if(Number(timeStampArr[0])) {
                timeStampLabel = timeStampLabel + ` ${Number(timeStampArr[0])} hour`;
                if(Number(timeStampArr[0]) > 1) {
                  timeStampLabel = timeStampLabel + 's';
                }
              }
              if(Number(timeStampArr[1])) {
                timeStampLabel = timeStampLabel + ` ${Number(timeStampArr[1])} minute`;
                if(Number(timeStampArr[1]) > 1) {
                  timeStampLabel = timeStampLabel + 's';
                }
              }
              if(Number(timeStampArr[2])) {
                timeStampLabel = timeStampLabel + ` ${Number(timeStampArr[2])} second`;
                if(Number(timeStampArr[2]) > 1) {
                  timeStampLabel = timeStampLabel + 's';
                }
              }
              return timeStampLabel;
            } else {
							if(label == '00:00:00') {
								return 0;
							} else {
								return label;
							}
            }
          } else if(labelArr && labelArr.length && labelArr.length == 1) {
            let timeStampArr = labelArr[0].split(':');
            if(timeStampArr && timeStampArr.length && timeStampArr.length == 3) {
              let timeStampLabel = `${labelArr[0]} ${labelArr[1]}`;
              if(Number(timeStampArr[0])) {
                timeStampLabel = timeStampLabel + ` ${Number(timeStampArr[0])} hour`;
                if(Number(timeStampArr[0]) > 1) {
                  timeStampLabel = timeStampLabel + 's';
                }
              }
              if(Number(timeStampArr[1])) {
                timeStampLabel = timeStampLabel + ` ${Number(timeStampArr[1])} minute`;
                if(Number(timeStampArr[1]) > 1) {
                  timeStampLabel = timeStampLabel + 's';
                }
              }
              if(Number(timeStampArr[2])) {
                timeStampLabel = timeStampLabel + ` ${Number(timeStampArr[2])} second`;
                if(Number(timeStampArr[2]) > 1) {
                  timeStampLabel = timeStampLabel + 's';
                }
              }
              return timeStampLabel;
            } else {
              if(label == '00:00:00') {
								return 0;
							} else {
								return label;
							}
            }
          } else {
            if(label == '00:00:00') {
							return 0;
						} else {
							return label;
						}
          }
        } else {
          if(val == '0 days 00:00:00') {
						return 0;
					} else {
						return val;
					}
        }
      } else {
        if(val == '0 days 00:00:00') {
					return 0;
				} else {
					return val;
				}
      }
		},
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    titleCase(str) {
      return str.replace(
        /\w\S*/g,
        function(txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
      );
    },
	},
	computed: {
		...mapState("TicketDashboardStore", [
			"ticketsDashboardSummary",
			"ticketDashboardTabName",
			"selectedLocation",
			"reportView",
			"fromDate",
			"toDate",
			"reportType",
			"reportTypeValue",
			"ticketData",
			"outletList",
			"categoryList",
			"isDashboardLoading",
			"ticketLocationDashboardBasics",
			"ticketDashboardCountries",
			"ticketDashboardRegions",
			"ticketDashboardSubregions",
			"ticketDashboardOutlets",
		]),
		tickets_dashboard_summary: {
			get() {
				return this.ticketsDashboardSummary;
			},
			set(value) {
				this.$store.commit(
					"TicketDashboardStore/updateTicketsDashboardSummary",
					value
				);
			},
		},
		ticket_dashboard_tab_name: {
			get() {
				return this.ticketDashboardTabName;
			},
			set(value) {
				this.$store.commit(
					"TicketDashboardStore/updateTicketDashboardTabName",
					value
				);
			},
		},
		selected_location: {
			get() {
				return this.selectedLocation;
			},
			set(value) {
				this.$store.commit(
					"TicketDashboardStore/updateSelectedLocation",
					value
				);
			},
		},
		report_view: {
			get() {
				return this.reportView;
			},
			set(value) {
				this.$store.commit(
					"TicketDashboardStore/updateReportView",
					value
				);
			},
		},
		from_date: {
			get() {
				return this.fromDate;
			},
			set(value) {
				this.$store.commit("TicketDashboardStore/updateFromDate", value);
			},
		},
		to_date: {
			get() {
				return this.toDate;
			},
			set(value) {
				this.$store.commit("TicketDashboardStore/updateToDate", value);
			},
		},
		report_type: {
			get() {
				return this.reportType;
			},
			set(value) {
				this.$store.commit("TicketDashboardStore/updateReportType", value);
			},
		},
		report_type_value: {
			get() {
				return this.reportTypeValue;
			},
			set(value) {
				this.$store.commit("TicketDashboardStore/updateReportTypeValue", value);
			},
		},
		dashboardGraph() {
			let result;

			switch (this.report_type) {
				case "location":
					result = "location-graph";
					break;
				case "agent":
					result = "agent-graph";
					break;
				case "priority":
					result = "priority-graph";
					break;
				case "resolution":
					result = "resolution-graph";
					break;
				case "category":
					result = "category-graph";
					break;
				default:
					result = "location-graph";
					break;
			}

			return result;
		},
		dashboardTable() {
			let result;

			switch (this.report_type) {
				case "location":
					result = "location-table";
					break;
				case "agent":
					result = "agent-table";
					break;
				case "priority":
					result = "priority-table";
					break;
				case "resolution":
					result = "resolution-table";
					break;
				case "category":
					result = "category-table";
					break;
				default:
					result = "location-table";
					break;
			}

			return result;
		},
		ticket_data: {
			get() {
				return this.ticketData;
			},
			set(value) {
				this.$store.commit("TicketDashboardStore/updateTicketData", value);
			},
		},
    apiBasics() {
			let result;

			switch (this.report_type) {
				case "location":
					// result = this.ticket_location_dashboard_basics ? this.ticket_location_dashboard_basics : "outlet";
					result = "outlet";
					break;
				case "agent":
					result = "user";
					break;
				case "priority":
					result = "priority";
					break;
				case "resolution":
					result = "priority";
					break;
				case "category":
					result = "category";
					break;
				default:
					result = "outlet";
					break;
			}

			return result;
		},
    outlet_list: {
      get() {
        return this.outletList;
      },
      set(value) {
        this.$store.commit("TicketDashboardStore/updateOutletList", value);
      }
    },
    category_list: {
      get() {
        return this.categoryList;
      },
      set(value) {
        this.$store.commit("TicketDashboardStore/updateCategoryList", value);
      }
    },
		is_dashboard_loading: {
			get() {
				return this.isDashboardLoading;
			},
			set(val) {
				this.$store.commit("TicketDashboardStore/updateIsDashboardLoading", val);
			}
		},
		ticket_location_dashboard_basics: {
			get() {
				return this.ticketLocationDashboardBasics;
			},
			set(val) {
				this.$store.commit("TicketDashboardStore/updateTicketLocationDashboardBasics", val);
			}
		},
		ticket_dashboard_countries: {
			get() {
				return this.ticketDashboardCountries;
			},
			set(val) {
				this.$store.commit("TicketDashboardStore/updateTicketDashboardCountries", val);
			}
		},
		ticket_dashboard_regions: {
			get() {
				return this.ticketDashboardRegions;
			},
			set(val) {

				this.$store.commit("TicketDashboardStore/updateTicketDashboardRegions", val);
			}
		},
		ticket_dashboard_subregions: {
			get() {
				return this.ticketDashboardSubregions;
			},
			set(val) {
				this.$store.commit("TicketDashboardStore/updateTicketDashboardSubregions", val);
			}
		},
		ticket_dashboard_outlets: {
			get() {
				return this.ticketDashboardOutlets;
			},
			set(val) {
				this.$store.commit("TicketDashboardStore/updateTicketDashboardOutlets", val);
			}
		},
  },
	methods: {
		async getTicketsDashboardReports() {
			this.is_dashboard_loading = true;
			const params = {
				start_date: moment(new Date(this.from_date)).format('YYYY-MM-DD'),
				end_date: moment(new Date(this.to_date)).format('YYYY-MM-DD'),
				basics: this.apiBasics,
				filters: {
					// countries: this.ticket_dashboard_countries,
					// regions: this.ticket_dashboard_regions,
					// subregions: this.ticket_dashboard_subregions,
					outlets: this.selected_location ? [this.selected_location] : [],
					// outlets: this.ticket_dashboard_outlets,
				},
				incident_categories: this.report_type_value.filter(el => el),
			};

			await ticketsService
				.getTicketsDashboardData(params)
				.then((response) => {
					let responseData = JSON.parse(response.data);
					if(responseData && responseData.data && responseData.data.length) {
						this.ticket_data = responseData.data.map(el => ({...el, average_rt: Number(el.average_rt)}))
						this.tickets_dashboard_summary = responseData.summary;
					}
				})
				.catch((error) => {
					console.error(error);
				})
				.finally(result => {
					this.is_dashboard_loading = false;
				});
		},
    showDateByQueryReport(view) {
      if (view == "wtd") {
        let dt = new Date(); // current date of week
        let currentWeekDay = dt.getDay();
        let lessDays = currentWeekDay == 0 ? 6 : currentWeekDay - 1;
        let wkStart = new Date(new Date(dt).setDate(dt.getDate() - lessDays));
        let wkEnd = "";
        wkEnd = new Date(new Date(wkStart).setDate(wkStart.getDate() + 6));
        if (wkEnd > new Date() && wkStart < new Date()) {
          wkEnd = new Date();
        }
        this.from_date = moment(wkStart).format("YYYY-MM-DD");
        this.to_date = moment(dt).format("YYYY-MM-DD");
      } else if (view == "mtd") {
        let date = new Date();
        let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        this.from_date = moment(firstDay).format("YYYY-MM-DD");
        this.to_date = moment(date).format("YYYY-MM-DD");
      } else if (view == "ytd") {
        let date = new Date(new Date().getFullYear(), 0, 1);
        this.from_date = moment(date).format("YYYY-MM-DD");
        this.to_date = moment(new Date()).format("YYYY-MM-DD");
      }
    },
    disabledTaskReportToDate(time) {
      let fromDate = new Date(this.from_date);
			return time.getTime() >= fromDate.getTime() && time.getTime() > Date.now();
    },
    disabledDueDate(time) {
			return time.getTime() > Date.now();
    },
		async getAllIncidentCategories() {
			await ticketDashboardService.getAllIncidentCategories()
			.then(res => {
				let responseData = JSON.parse(res.data);
				this.category_list = responseData;
			})
			.catch(error => console.error(error));
		},
	},
};
